/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Model = exports.Configuration = void 0;

var axios_1 = __importDefault(require("axios"));

var axios_retry_1 = __importDefault(require("axios-retry"));

var brightsmith_core_1 = require("brightsmith-core");

var constants_1 = require("../constants");

axios_retry_1.default(axios_1.default, {
  retries: 3
});

var error = function error(type, _error) {
  return {
    type: type,
    isLoading: false,
    error: _error
  };
};

var request = function request(type) {
  return {
    type: type,
    isLoading: true
  };
};

var receive = function receive(response, type) {
  return {
    type: type,
    isLoading: false,
    hasLoaded: true,
    response: response
  };
};

var Configuration = {
  get: function get(configurationCode) {
    return function (dispatch) {
      dispatch(request(constants_1.API.REQUEST));
      return brightsmith_core_1.Api.configuration.GET(configurationCode).then(function (json) {
        if (json) {
          console.log('received', json);
          return dispatch(receive(json, constants_1.CONFIGURATION.RECEIVE));
        }

        return dispatch(error(constants_1.API.ERROR, {}));
      }).catch(function (err) {
        console.log('An error occurred', err);
        dispatch(error(constants_1.API.ERROR, err));
      });
    };
  },
  receive: function receive(response) {
    return {
      type: constants_1.CONFIGURATION.RECEIVE,
      isLoading: false,
      hasLoaded: true,
      response: response
    };
  },
  reset: function reset() {
    return {
      type: constants_1.CONFIGURATION.RESET
    };
  },
  set: function set(configuration) {
    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return {
      type: constants_1.CONFIGURATION.SET,
      configuration: configuration,
      overrides: overrides
    };
  },
  setConfigCode: function setConfigCode(configCode) {
    return {
      type: constants_1.CONFIGURATION.SET_CONFIG_CODE,
      configCode: configCode
    };
  },
  stash: function stash(configuration) {
    return {
      type: constants_1.CONFIGURATION.STASH,
      configuration: configuration
    };
  }
};
exports.Configuration = Configuration;
var Model = {
  fetch: function fetch(modelId, env, opts) {
    var apiRoot = env.BRIGHTSMITH_API_ROOT;
    return function (dispatch) {
      dispatch(request(constants_1.API.REQUEST));

      if (opts === null || opts === void 0 ? void 0 : opts.data) {
        var data = opts.data;
        return dispatch(receive({
          data: data
        }, constants_1.API.RECEIVE));
      }

      var url = "".concat(apiRoot, "model/").concat(modelId);
      return axios_1.default.get(url).then(function (json) {
        if (json) {
          console.log('received', json, json.data, typeof json.data);

          if (typeof json === 'string') {
            return dispatch(receive(JSON.parse(json), constants_1.API.RECEIVE));
          }

          return dispatch(receive(json, constants_1.API.RECEIVE));
        }

        return dispatch(error(constants_1.API.ERROR, {}));
      }).catch(function (err) {
        console.error('An error occurred', err);
        dispatch(error(constants_1.API.ERROR, err));
      });
    };
  },
  fetchAll: function fetchAll(env) {
    var apiRoot = env.BRIGHTSMITH_API_ROOT;
    return function (dispatch) {
      dispatch(request(constants_1.API.REQUEST));
      var url = "".concat(apiRoot, "models");
      console.log(url);
      return axios_1.default.get(url).then(function (json) {
        if (json) {
          console.log('received', json);
          return dispatch(receive(json, constants_1.API.RECEIVE));
        }
      }).catch(function (err) {
        console.error('An error occurred', err);
        dispatch(error(constants_1.API.ERROR, err));
      });
    };
  },
  reset: function reset() {
    return {
      type: constants_1.API.RESET,
      isLoading: false,
      hasLoaded: false
    };
  }
};
exports.Model = Model;